import { ICallLiveInterval } from '../call/types'

export function convertToPlayerTime(intervals: ICallLiveInterval[], rawTime: number) {
  if (intervals.length === 0) {
    return rawTime
  }
  let playerTime = 0
  for (const intv of intervals) {
    if (intv.start_time <= rawTime && intv.end_time <= rawTime) {
      playerTime += intv.end_time - intv.start_time
    } else if (intv.start_time <= rawTime && rawTime <= intv.end_time) {
      playerTime += rawTime - intv.start_time
    } else {
      break
    }
  }
  return playerTime
}

export function convertFromPlayerTime(intervals: ICallLiveInterval[], playerTime: number) {
  if (intervals.length === 0) {
    return playerTime
  }
  let rawTime = 0
  for (const intv of intervals) {
    const d = intv.end_time - intv.start_time
    if (playerTime > d) {
      playerTime -= d
      rawTime = intv.end_time
    } else {
      rawTime = intv.start_time + playerTime
      break
    }
  }
  return rawTime
}
